import styled from '@emotion/styled'

const InvitationDialogCopy = styled('div')({
  lineHeight: 1.5
})

export default InvitationDialogCopy
